import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { type IUnmatchedListing } from 'src/services/api/listings/types';

type IGetUnmatchedListingsOptions = {
    disabled?: boolean;
    refetchInterval?: number;
};

type IRawUnmatchedListing = Omit<IUnmatchedListing, 'id' | 'ingestion_provider'> & {
    listing_id: number;
    ingestion_source: string;
};

const GET_UNMATCHED_LISTINGS_PATH = 'api/landlord/listings/unmatched';

function mapUnmatchedListing(raw: IRawUnmatchedListing): IUnmatchedListing {
    const { listing_id: listingId, ingestion_source: ingestionSource, ...rest } = raw;
    return { ...rest, id: listingId, ingestion_provider: ingestionSource };
}

export const useUnmatchedListings = (options?: IGetUnmatchedListingsOptions) => {
    return useQuery(
        [queryKeys.listings, { isMatched: false }],
        async () => {
            const res = await apiClient(GET_UNMATCHED_LISTINGS_PATH, {
            }).json<{ unmatched: IRawUnmatchedListing[] }>();
            return { unmatched: res.unmatched.map(mapUnmatchedListing) };
        },
        {
            enabled: !options?.disabled,
            keepPreviousData: true,
            refetchInterval: options?.refetchInterval,
        }
    );
};
